import { Routes, Route, Outlet, Navigate } from "react-router-dom";
import Login from "../Pages/Login/Login";
import Home from "../Pages/Home/Home";
import UserRegistration from "../Pages/UserRegistration/UserRegistration";
import Navbar from "../components/Navbar/navbar";
import Footer from "../components/Footer/Footer";
import Users from "../Pages/User/Users";
import Os from "../Pages/Os/Os";
import CadastrarEmpresa from "../Pages/Enterprise/Enterprise";
import ManageBranches from "../Pages/ManageBranches/ManageBranches";
import EditarOs from "../Pages/Os/EditarOs";
import CadastroOpcoesOs from "../Pages/Optionsregistration/CadastroOpcoesOs";
import ProtectedRoute from "../components/ProtectedRoute";
import Landing from "../Pages/Landing/Landing";
import ProjectDetail from "../Pages/ProjectDetail/ProjectDetail";
import PublicOsExecution from "../Pages/OsExecution/PublicOsExecution";
import Denuncias from "../Pages/Denuncias/Denuncias";
import Permissions from "../Pages/Permissions/Permissions";

const MainLayout = () => {
  return (
    <>
      <Navbar />
      <div className="content">
        <Outlet />
      </div>
      <Footer />
    </>
  );
};

export default function AppRoutes() {
  return (
    <div className="app-container">
      <Routes>
        <Route path="/" element={<Landing modern />} />
        <Route path="/site-novo" element={<Navigate to="/" replace />} />
        <Route path="/login" element={<Login />} />
        <Route path="/os/public/:token" element={<PublicOsExecution />} />
        <Route
          path="/conjunto-comercial-plinio-correa"
          element={<ProjectDetail />}
        />
        <Route
          path="/galpao-industrial-sao-cristovao"
          element={<ProjectDetail />}
        />
        <Route path="/condominio-vila-nova" element={<ProjectDetail />} />
        <Route
          path="/infraestrutura-do-loteamento-jatoba"
          element={<ProjectDetail />}
        />
        <Route path="/projetos/:slug" element={<ProjectDetail />} />

        <Route element={<ProtectedRoute />}>
          <Route element={<MainLayout />}>
            <Route path="/home" element={<Home useModernLayout />} />
            <Route path="/home-novo" element={<Navigate to="/home" replace />} />

            <Route path="/cadastro-usuario" element={<UserRegistration modern />} />
            <Route
              path="/cadastro-usuario-novo"
              element={<Navigate to="/cadastro-usuario" replace />}
            />

            <Route path="/usuario" element={<Users modern />} />
            <Route path="/usuario-novo" element={<Navigate to="/usuario" replace />} />

            <Route path="/criacao-os" element={<Os modern />} />
            <Route
              path="/criacao-os-novo"
              element={<Navigate to="/criacao-os" replace />}
            />

            <Route path="/os/editar/:id" element={<EditarOs />} />

            <Route path="/cadastroOpcoes" element={<CadastroOpcoesOs modern />} />
            <Route
              path="/cadastroOpcoes-novo"
              element={<Navigate to="/cadastroOpcoes" replace />}
            />

            <Route path="/CadastrarEmpresa" element={<CadastrarEmpresa modern />} />
            <Route
              path="/CadastrarEmpresa-novo"
              element={<Navigate to="/CadastrarEmpresa" replace />}
            />

            <Route path="/ConsultaEmpresas" element={<ManageBranches modern />} />
            <Route
              path="/ConsultaEmpresas-novo"
              element={<Navigate to="/ConsultaEmpresas" replace />}
            />

            <Route path="/consulta-denuncias" element={<Denuncias modern />} />
            <Route
              path="/consulta-denuncias-novo"
              element={<Navigate to="/consulta-denuncias" replace />}
            />

            <Route path="/permissoes" element={<Permissions modern />} />
            <Route
              path="/permissoes-novo"
              element={<Navigate to="/permissoes" replace />}
            />
          </Route>
        </Route>

        <Route path="*" element={<div>Página não encontrada!</div>} />
      </Routes>
    </div>
  );
}
